export default __webpack_public_path__ + "3b02372.png";